<template>
  <transition :name="transitionName" @after-leave="onLeave" appear>
    <div @click.stop="() => $emit('click')" class="dialog" ref="dialog">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import pageStack from '@utils/pageLocker';
export default {
  props: {
    transitionName: {
      type: String,
      default: 'dialog-fade'
    },
    disableLock: Boolean
  },
  methods: {
    onLeave() {
      this.$root.$emit('dialog-leave');
      pageStack.unlock();
    }
  },
  mounted() {
    pageStack.lock();
    pageStack.push(this.$el);
  },
  beforeDestroy() {
    pageStack.pop();
  }
};
</script>

<style lang="scss">
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 600;
}
.dialog-wrapper {
  position: relative;
  top: 50%;
  left: 50%;
  width: 618px;
  padding: 54px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 15px;
  transform: translate3d(-50%, -50%, 0);
  z-index: 1600;
}
.dialog-btn-close {
  position: absolute;
  z-index: 10;
  top: 30px;
  right: 30px;
  width: 24px;
  height: 24px;
  background: url(@/assets/imgs/icon-close.png) no-repeat center/100% 100%;
  &:active {
    transform: scale(0.8);
  }
}
.form-item {
  border-bottom: 1px solid #d9d9d9;
  margin-top: 36px;
  align-items: center;
  .form-control-input {
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 24px;
    padding: 0 10px;
    border: none;
    vertical-align: middle;
  }
}
.dialog-btn-submit {
  background: #ffc341;
  border-radius: 50px;
  width: 100%;
  height: 90px;
  line-height: 90px;
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  color: #333;
  margin-top: 50px;
  border: none;
  letter-spacing: 2px;
  &--disabled {
    filter: grayscale(1);
    &:active {
      transform: scale(1);
    }
  }
}
.dialog-btn-min {
  border: none;
  background: #ffc341;
  border-radius: 50px;
  height: 90px;
  line-height: 90px;
  width: 70%;
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  color: #333;
  margin: 50px auto 0;
  letter-spacing: 2px;
  &--disabled {
    filter: grayscale(1);
    &:active {
      transform: scale(1);
    }
  }
}
</style>
